export const BOX_DICE_EMAIL_TEMPLATE = {
  to: 'support@boxdice.com',
  cc: 'help@snug.com',
  subject: 'Enable Snug as Upload Destination - Agency Setup',
  body: `Hello Box+Dice

Could you please enable Snug as an upload destination for our agency for the Box+Dice Account(s):

- [Enter your Agency ID here]

Please assign the Box+Dice Agency ID and provide it to us.

Thank you,

Head of Property Management`,
}
